export default __webpack_public_path__ + "assets/images/aistudio/empty_state/edbe381a70d14832dd5a0bffd4985f78.png";